export default __webpack_public_path__ + "static/media/error.a109431b.svg";